import { Injectable, inject } from '@angular/core';
import { ApiService, Franchise } from '@franbase/shared/data-access';
import { ComponentStore } from '@ngrx/component-store';
import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { EMPTY, Observable, mergeMap, tap } from 'rxjs';

interface FranchiseState extends EntityState<any> {
  error: string,
  loading: boolean
}
const adapter = createEntityAdapter<any>();
const initialState: FranchiseState = adapter.getInitialState({
  error: '',
  loading: true
})

const { selectAll } = adapter.getSelectors();

@Injectable({
  providedIn: 'root'
})
export class FranchiseStoreService extends ComponentStore<FranchiseState> {

  apiSV = inject(ApiService);

  constructor() { super(initialState); }

  data$ = this.select(selectAll);
  loading$ = this.select((s) => s.loading);

  getFranchiseBySlug(slug: string) {
    return this.select(this.data$, (rs) => rs.filter(r => r.slug == slug)[0] as Franchise).pipe(
      tap(rs => {
        if (!rs) {
          console.log('lay moi');

          this.apiSV.franchiseDetail('slug', slug).then(rs => {
            if (rs.success) {
              this.setState((state) => adapter.setOne(rs.data, state));
              this.patchState({error: '', loading: false})
            } else {
              this.patchState({error: rs.message, loading: false});
            }
          }).catch(err => {
            this.patchState({error: err.message, loading: false});
          });
        } else {
          this.patchState({error: '', loading: false});
          console.log('co san');
        }
      })
    );
  }

  addOneFranchise$ = this.effect((franchise$: Observable<Franchise>)=> {
    return franchise$.pipe(
      mergeMap((franchise) => {
        if (franchise) {
          this.setState((state) => adapter.setOne(franchise, state));
        }
        return EMPTY;
      })
    )
  })

  addManyFranchise$ = this.effect((list_franchise$: Observable<Franchise[]>)=> {
    return list_franchise$.pipe(
      mergeMap((list_franchise) => {
        if (list_franchise && list_franchise.length > 0) {
          this.setState((state) => adapter.setMany(list_franchise, state));
        }
        return EMPTY;
      })
    )
  })

}
